import { render, staticRenderFns } from "./DeadlineReminderButton.vue?vue&type=template&id=3c9ff6c1"
import script from "./DeadlineReminderButton.vue?vue&type=script&lang=js"
export * from "./DeadlineReminderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports